import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import InputForm from '../../../components/InputForm/InputForm'

export default function ConfirmModal({
  onClose,
  isOpen,
  onConfirm,
  text,
  withPass,
  backBtn = 'Volver',
  continueBtn = 'Eliminar',
}) {
  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')
  const handleChangeUser = (event) => {
    setUser(event.target.value)
  }
  const handleChangePassword = (event) => {
    setPassword(event.target.value)
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent width={344}>
        <ModalCloseButton />
        <ModalBody>
          <VStack>
            <FontAwesomeIcon icon={faWarning} color="#FFC107" size="7x" />
            <VStack py={5}>
              <Text textAlign="center">{text}</Text>
              {withPass && (
                <VStack spacing="24px" alignItems="flex-start" w="100%">
                  <VStack w="100%">
                    <InputForm
                      stackProps={{ width: '100%' }}
                      onChange={handleChangeUser}
                      value={user}
                      titleHeading
                      variant="h6"
                      w="100%"
                      title={'Usuario'}
                    />
                  </VStack>
                  <VStack w="100%">
                    <InputForm
                      type="password"
                      stackProps={{ width: '100%' }}
                      onChange={handleChangePassword}
                      value={password}
                      titleHeading
                      variant="h6"
                      w="100%"
                      title={'Clave'}
                    />
                  </VStack>
                </VStack>
              )}
            </VStack>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            mr={3}
            borderRadius={5}
            onClick={onClose}
            colorScheme="black"
            borderColor="#565656"
            backgroundColor="#565656"
          >
            {backBtn}
          </Button>
          <Button
            variant="error"
            borderRadius={5}
            onClick={withPass ? () => onConfirm(user, password) : onConfirm}
          >
            {continueBtn}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  text: PropTypes.string,
  withPass: PropTypes.bool,
  backBtn: PropTypes.string,
  continueBtn: PropTypes.string,
}
